import AppInstallList from './src/app-install-template';

export default AppInstallList;
